// flexinet-testing-api
//
// Endpoints are READ from the deployed AppSync APIs (`aws appsync list-graphql-apis`),
// never derived from an apiId — the endpoint host and the apiId diverge. For
// reference, dev's apiId is `ctwzwnqw55codkmvf3jrwapuri` while its host is
// `va6nwhrwivfmrd5ehnjv3qvsde`.
//
// There is deliberately NO prod entry: the testing-api prod stack exists, but the
// synthetic-user fleet is dev-only by decision (FNP-847). Pointing a prod console
// at the test API would let a prod admin author rows for another environment, so
// prod resolves to `undefined` and the Autonomous Testing menu group is hidden.
import {stage} from '../../../config/stage.ts';

type TestingApiStageConfig = {
    endpoint: string,
    region: string,
};

const testingApi: Partial<Record<typeof stage, TestingApiStageConfig>> = {
    test: {
        endpoint: 'https://5wmxfyfgtjagzciannpvhw3o5a.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    dev: {
        endpoint: 'https://va6nwhrwivfmrd5ehnjv3qvsde.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    ide: {
        endpoint: 'https://va6nwhrwivfmrd5ehnjv3qvsde.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
};

export const testingApiConfig = testingApi[stage];

export const testingApiAvailable = typeof testingApiConfig !== 'undefined';
